import React, { useRef, useState } from "react";
import collective from "../assets/image/collective.jpeg";
import about1 from "../assets/image/about1.jpeg";
import about2 from "../assets/image/about2.jpeg";
import about3 from "../assets/image/about3.jpeg";
import about4 from "../assets/image/about4.jpeg";
import about5 from "../assets/image/about5.jpeg";
import about6 from "../assets/image/about6.jpeg";
import { NavLink } from "react-router-dom";
const About = () => {
  const videoRef = useRef(null); // Video elementini referansla izləmək
  const [isPlaying, setIsPlaying] = useState(false); // Videonun oynayıb-oynamadığını izləmək

  // Play düyməsinə basıldıqda işə düşəcək funksiyanı yaratmaq
  const handlePlayPauseClick = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause(); // Videonu dayandır
      } else {
        videoRef.current.play(); // Videonu başlat
      }
      setIsPlaying(!isPlaying); // `isPlaying` state-i dəyişdir
    }
  };
  return (
    <>
      <div>
        <div className="about-section section  section-padding-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 order-lg-1 order-2">
                <div className="about-content mt-sm-50 mt-xs-50">
                  <span className="sub-title" style={{ textTransform: "none" }}>
                    Bizim Haqqımızda
                  </span>
                  <h2 className="title">
                    <span>Biz </span> Kimik
                  </h2>
                  <p>
                    ÖİC olaraq bizim əsas məqsədimiz təkcə investisiya
                    vasitəçisi kimi fəaliyyət göstərmək deyil, həm də
                    sahibkarlara layihələrinin ideya mərhələsindən reallaşmasına
                    qədər hər mərhələdə dəstək olmaqdır. Biz həmçinin
                    layihələrin marketinqi və paylanması üçün tələb olunan
                    mentorluq və şəbəkələşmə kimi resursları təmin edirik.
                    Layihələrinə sərmayə qoyulan sahibkarlar yalnız aldıqları
                    sərmayə ilə səyahətlərini davam etdirmirlər, həm də öz
                    sahələrində mütəxəssis olan təsisçilərimizlə əlaqə qurur,
                    bilik və təcrübələrini bölüşürlər. Özbahçeci İnvest klubu öz
                    sahəsində 35 ildən artıq təcrübəyə malik qurucularımızla
                    yeni addımlarda tərəfdaşlıq etmək üçün işləməyə davam edir.
                  </p>
                  <a className="link link-lg" href="#">
                    <mark>
                      Daha çox oxu <i className="fas fa-arrow-right" />
                    </mark>
                  </a>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 order-lg-1 order-1">
                <div className="about-image">
                  <div className="about-image-one">
                    <img src={collective} alt="about01" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* About Section End */}
        {/* About Video Section Start */}
        <div className="about-video-section section section-padding-bottom">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5">
                {/* About Me Video Wrapper Start */}
                <div className="about-me-video-wrapper about-us-one-video pr-55 pr-sm-0 pr-xs-0">
                  {/* About Me Video Start */}
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      maxWidth: "600px",
                    }}
                  >
                    <video
                      ref={videoRef}
                      className="presto-player__player"
                      preload="auto"
                      playsInline
                      style={{ width: "100%", height: "80%" }}
                    >
                      <source src="https://www.ozbahceciinvest.com/wp-content/uploads/2024/08/Turan-Ozbahceci.mp4" />
                    </video>

                    {/* Play/Pause düyməsi */}
                    <div
                      className="play-button"
                      onClick={handlePlayPauseClick}
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "50px",
                        color: "white",
                        cursor: "pointer",
                        zIndex: 2,
                      }}
                    >
                      {isPlaying ? "❚❚" : "►"}{" "}
                      {/* Play işarəsi (►) və Pause işarəsi (❚❚) */}
                    </div>
                  </div>
                </div>
                {/* About Me Video Wrapper End */}
              </div>
              <div className="col-lg-7 bg-p">
                <div className="about-content  " style={{ maxWidth: "100%" }}>
                  <span
                    className="sub-title"
                    style={{ textTransform: "uppercase" }}
                  >
                    Bİrlİkdə İnKİŞAF edək!
                  </span>
                  <h2 className="title">
                    Sahibkarlıq Ruhunu Dəstəkləyən <span>İnvestor Klubu</span>{" "}
                  </h2>
                  <p>
                    Bizim missiyamız innovativ ideyaları olan sahibkarları
                    investorlarla bir araya gətirməkdir. Layihələrinizi
                    reallaşdırmaq üçün bizimlə əlaqəyə keçin.
                  </p>
                  <a className="link link-lg" href="https://www.ozbahceciinvest.com/about/" target="_blank">
                    <mark>
                      Bizlə Əlaqə <i className="fas fa-arrow-right" />
                    </mark>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="cta-section section section-padding-bottom"
          data-bg-color="#f5f5f5"
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="cta-content text-center">
                  <span className="sub-title">
                    Niyə Özbahçeci İnvestisiya Klubuna{" "}
                    <span>üzv olmalısınız?</span>
                  </span>
                  <div className="d-flex justify-content-center align-items-center">
                    <h2
                      className="title"
                      style={{
                        fontSize: "17px",
                        color: "grey",
                        fontWeight: "normal",
                        maxWidth: "800px",
                        width: "100%",
                      }}
                    >
                      Bizneslər Şirkətinizin böyüməsini sürətləndirmək üçün
                      50.000 – 10.000.000 ABŞ dolları arasında investisiyalar
                      ala bilərsiniz. 3-4 həftə ərzində investisiya təsdiqi
                      komandamız layihənizi nəzərdən keçirəcək və sizin üçün
                      ətraflı hesabat hazırlayacaq
                    </h2>
                  </div>
                  <a
                    href="https://www.ozbahceciinvest.com/contact/"
                    target="_blank"
                    className="btn btn-primary btn-hover-secondary btn-width-300"
                  >
                    {" "}
                    Bizlə Əlaqə
                  </a>
                  <div className="shape shape-2 scene">
                    <span data-depth={4}>
                      <img
                        src="assets/images/shape-animation/cta-shape-01.png"
                        alt
                      />
                    </span>
                  </div>
                  <div className="shape shape-3 scene">
                    <span data-depth={4}>
                      <img
                        src="assets/images/shape-animation/nwesletter-shape-2.png"
                        alt
                      />
                    </span>
                  </div>
                  {/* Animation Shape End */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Section End */}
        {/* Team Section Start */}
        <div className="team-section section section-padding-top">
          <div className="container">
            {/* Section Title Start */}
            <div className="section-title text-center" data-aos="fade-up">
              <h2 className="title fz-48">
                İdarə <span> Heyəti</span>
              </h2>
            </div>
            {/* Section Title End */}
            <div className="row ht-team-member-style-two justify-content-center pb-5">
              <div className="col-lg-3 col-md-6 col-sm-6 max-mb-50">
                <div className="grid-item">
                  <div className="ht-team-member">
                    <div className="team-image">
                      <img
                        className="img-fluid"
                        style={{ height: "400px", objectFit: "cover" }}
                        src={about1}
                        alt
                      />
                      <div className="social-networks">
                        <div className="inner">
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce  hint--top hint--theme-two"
                            aria-label="Facebook"
                          >
                            <i className="fab fa-facebook-f" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Twitter"
                          >
                            <i className="fab fa-twitter" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Instagram"
                          >
                            <i className="fab fa-instagram" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Youtube"
                          >
                            <i className="fab fa-youtube" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="team-info text-center">
                      <h5 className="name">Turan Özbahçeci </h5>
                      <div className="position">Prezident</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 max-mb-50">
                <div className="grid-item">
                  <div className="ht-team-member">
                    <div className="team-image">
                      <img
                        className="img-fluid"
                        style={{ height: "400px", objectFit: "cover" }}
                        src={about2}
                        alt
                      />
                      <div className="social-networks">
                        <div className="inner">
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce  hint--top hint--theme-two"
                            aria-label="Facebook"
                          >
                            <i className="fab fa-facebook-f" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Twitter"
                          >
                            <i className="fab fa-twitter" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Instagram"
                          >
                            <i className="fab fa-instagram" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Youtube"
                          >
                            <i className="fab fa-youtube" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="team-info text-center">
                      <h5 className="name">Doğan Tomris</h5>
                      <div className="position">İnvest Club Danışmanı</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 max-mb-50">
                <div className="grid-item">
                  <div className="ht-team-member">
                    <div className="team-image">
                      <img
                        className="img-fluid"
                        style={{ height: "400px", objectFit: "cover" }}
                        src={about3}
                        alt
                      />
                      <div className="social-networks">
                        <div className="inner">
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce  hint--top hint--theme-two"
                            aria-label="Facebook"
                          >
                            <i className="fab fa-facebook-f" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Twitter"
                          >
                            <i className="fab fa-twitter" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Instagram"
                          >
                            <i className="fab fa-instagram" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Youtube"
                          >
                            <i className="fab fa-youtube" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="team-info text-center">
                      <h5 className="name">Kamil Bağırov </h5>
                      <div className="position">İnvest Komitə Müdürü</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 max-mb-50">
                <div className="grid-item">
                  <div className="ht-team-member">
                    <div className="team-image">
                      <img
                        className="img-fluid"
                        style={{ height: "400px", objectFit: "cover" }}
                        src={about4}
                        alt
                      />
                      <div className="social-networks">
                        <div className="inner">
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce  hint--top hint--theme-two"
                            aria-label="Facebook"
                          >
                            <i className="fab fa-facebook-f" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Twitter"
                          >
                            <i className="fab fa-twitter" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Instagram"
                          >
                            <i className="fab fa-instagram" />
                          </a>
                          <a
                            target="_blank"
                            href="JavaScript:Void(0);"
                            className=" hint--bounce hint--top hint--theme-two"
                            aria-label="Youtube"
                          >
                            <i className="fab fa-youtube" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="team-info text-center">
                      <h5 className="name">Nəzrin Sadıxova </h5>
                      <div className="position">Vitse-Prezident</div>
                    </div>
                  </div>
                </div>
              </div>
              <NavLink to="/managementboard"
                className="btn btn-primary btn-hover-secondary btn-width-300 fs-6"
              >
                {" "}
                Daha ətraflı
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
